import React, { FC, HTMLAttributes } from 'react';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import { ArrowRight } from '@shared/assets/icons';
import { NavbarItemType } from '../model/navbar.model';
interface MoreModalItemProps extends HTMLAttributes<HTMLDivElement> {
  isActive: boolean;
  item: NavbarItemType;
}
const MoreModalItem: FC<MoreModalItemProps> = ({
  isActive,
  item,
  ...rest
}) => <Link passHref href={item.href as string}>
    <MoreModalItemWrapper {...rest}>
      <ContentWrapper>
        <IconWrapper isActive={isActive}>{item.icon}</IconWrapper>
        <Text family="MTSWide" size="pM" weight="medium" color={isActive ? 'accent' : 'primary'}>
          {item.label}
        </Text>
      </ContentWrapper>
      <ArrowWrapper isActive={isActive}>
        <ArrowRight />
      </ArrowWrapper>
    </MoreModalItemWrapper>
  </Link>;
export default MoreModalItem;
const MoreModalItemWrapper = /*#__PURE__*/styled('div')({
  name: "MoreModalItemWrapper",
  class: "m1e88ysh",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1hwc5sz",
  propsAsIs: false
});
type IconWrapperProps = Required<Pick<MoreModalItemProps, 'isActive'>>;
const _exp = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.icon.accent : theme.colors.icon.primary;
const IconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1xpwsn9",
  propsAsIs: false,
  vars: {
    "i1xpwsn9-0": [_exp()]
  }
}));
type ArrowWrapperProps = Required<Pick<MoreModalItemProps, 'isActive'>>;
const _exp2 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.icon.accent : theme.colors.icon.secondary;
const ArrowWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ArrowWrapper",
  class: "a7d57e6",
  propsAsIs: false,
  vars: {
    "a7d57e6-0": [_exp2()]
  }
}));

require("./MoreModalItem.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./MoreModalItem.tsx");